import { render, staticRenderFns } from "./VerifyUser.vue?vue&type=template&id=8cfec9f0&scoped=true&"
import script from "./VerifyUser.vue?vue&type=script&lang=js&"
export * from "./VerifyUser.vue?vue&type=script&lang=js&"
import style0 from "./VerifyUser.vue?vue&type=style&index=0&id=8cfec9f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfec9f0",
  null
  
)

export default component.exports